import React from "react";

/* FormField wiring context (strategy §15, §25).
   Lives in lib so any tier can consume it without inverting the atomic
   layering: the FormField molecule PROVIDES it; atoms (Checkbox, Switch,
   RadioGroup) and molecules (Select, Combobox, DatePicker) READ it to apply
   the a11y contract appropriate to their own structure. */

export interface FormFieldContextValue {
  /** id of the control the label points at. */
  id: string;
  /** id of the <label> — for controls that label via aria-labelledby (groups). */
  labelId?: string | undefined;
  /** Space-joined ids of the hint and/or error to expose via aria-describedby. */
  describedBy?: string | undefined;
  invalid: boolean;
  required: boolean;
  disabled: boolean;
}

export const FormFieldContext =
  React.createContext<FormFieldContextValue | null>(null);

/** Read the enclosing FormField's wiring, or null when used standalone. */
export function useFormField(): FormFieldContextValue | null {
  return React.useContext(FormFieldContext);
}
